'use strict';

var ShapewaysView = require('./ShapewaysView');
var toggleTpl      = require('rrTags/truncate/templates/tpl.truncate-toggle.mustache');

var SHOW_MORE_TEXT = 'Show More';
var SHOW_LESS_TEXT = 'Show Less';
var IS_SHOWING_MORE_VAR = 'isShowingMore';
var TRUNCATION_LENGTH_VAR = 'truncationLength';

var Truncate = ShapewaysView.extend({

  swAttrs: {

    /**
     * The element w/ text to be truncated. You can pass truncation length to it
     * data-sw-truncate="100" will truncate after 100 chars
     */
    ROOT: 'data-sw-truncate',

    /**
     * This is the element that actually toggles the truncation
     */
    toggle: 'data-sw-truncate-toggle',

    /**
     * The text will be wrapped in this container for safe keeping between toggle
     */
    text: 'data-sw-truncate-text'

  },

  initialize: function initialize() {
    var size = this.$el.swDataAttr(this.swAttrs.ROOT);
    size = size === '' ? this.$el.swTruncate.DEFAULTS.length : size;
    this.state.set(TRUNCATION_LENGTH_VAR, size);

    if(!this.cachedElements.$text.length) {
      this.$el.html('<span ' + this.swAttrs.text + '>' + this.$el.html() + '</span>');
      this.cacheElements(this.swSelectors.text, '$text');
    }

    if(!this.cachedElements.$toggle.length) {
      var toggleString = toggleTpl.render({text: ''});
      this.cachedElements.$text.after(' ' + toggleString);
      this.cacheElements(this.swSelectors.toggle, '$toggle');
    }

    this.showLess();
  },

  events: function() {

    var eventsHash = {};

    eventsHash['click ' + this.swSelectors.toggle] = 'toggle';

    return eventsHash;
  },

  toggle: function toggle() {
    if(this.state.get(IS_SHOWING_MORE_VAR)) {
      this.showLess();
    } else {
      this.showMore();
    }
  },

  showMore: function showMore() {
    this.state.set(IS_SHOWING_MORE_VAR, true);
    this.cachedElements.$toggle.text(SHOW_LESS_TEXT);
    this.cachedElements.$text.swTruncate({ undo: true });
  },

  showLess: function showLess() {
    this.state.set(IS_SHOWING_MORE_VAR, false);
    this.cachedElements.$toggle.text(SHOW_MORE_TEXT);
    this.cachedElements.$text.swTruncate({
      size: this.state.get(TRUNCATION_LENGTH_VAR)
    });

    var DATA_ATTR  = this.cachedElements.$text.swTruncate.DATA_ATTR;
    var resultData = this.cachedElements.$text.data(DATA_ATTR.ROOT);
    if(!resultData[DATA_ATTR.OVER_LENGTH]) {
      this.hideToggle();
    }
  },

  hideToggle: function hideToggle() {
    this.cachedElements.$toggle.swHide();
  }

});

module.exports = Truncate;

